export enum AlarmType {
    SPEED_LIMIT = 'SPEED_LIMIT',
    EXIT_AREA = 'EXIT_AREA',
    ENTRY_AREA = 'ENTRY_AREA'
}
